;(function() {
  'use strict'

  angular.module('app.projects').component('projectsToolbar', {
    controller: Controller,
    templateUrl: 'projects-toolbar.html',
    bindings: {
      query: '<',
      filters: '<',
      filter: '<',
      filtersLabel: '@',
      sort: '<',
      sortOptions: '<',
      view: '<',
      onQueryChange: '&?',
      onFilterChange: '&',
      onSortChange: '&',
      onViewChange: '&?',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.clear = clear

    function clear() {
      ctrl.query = ''
      ctrl.onQueryChange({ $value: '' })
    }
  }
})()
